import { useEffect, useState } from "react"
import { getEngDiagStrandsForYear } from "../services/eng-diag.service"
import type { BmdStrand } from "../../bmd/types/bmd.types"

export type UseEngDiagStrandsState = {
  strands: BmdStrand[]
  lockedTopicIds: Set<number>
  loading: boolean
  error: string | null
}

/** The clusters at a year for the assign tab. Idle while there is no year. */
export function useEngDiagStrands(
  yearLevelId: number,
  studentKey?: string,
): UseEngDiagStrandsState {
  const [strands, setStrands] = useState<BmdStrand[]>([])
  const [lockedTopicIds, setLockedTopicIds] = useState<Set<number>>(new Set())
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!yearLevelId) {
      setStrands([])
      setLockedTopicIds(new Set())
      setLoading(false)
      setError(null)
      return
    }

    const controller = new AbortController()
    setLoading(true)
    setError(null)

    getEngDiagStrandsForYear(
      { year_level_id: yearLevelId, student_key: studentKey },
      controller.signal,
    )
      .then(res => {
        setStrands(res.strands)
        setLockedTopicIds(new Set(res.locked_topic_ids))
        setLoading(false)
      })
      .catch(err => {
        if (controller.signal.aborted) return
        setError(err?.message || "Failed to load diagnostics clusters")
        setStrands([])
        setLockedTopicIds(new Set())
        setLoading(false)
      })

    return () => controller.abort()
  }, [yearLevelId, studentKey])

  return { strands, lockedTopicIds, loading, error }
}
